const API = process.env.REACT_APP_BACKEND_URL;

/** Pull utm_source/medium/campaign/content from the current URL, if present. */
export function captureUtm() {
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach((k) => {
    const v = params.get(k);
    if (v) utm[k] = v;
  });
  return utm;
}

/**
 * Submit a Print Edition Interest registration. NOT a preorder, no
 * payment — see POST /api/print-interest on the backend.
 */
export async function submitPrintInterest(payload) {
  const res = await fetch(`${API}/api/print-interest`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...captureUtm(), ...payload }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = Array.isArray(data.detail) ? data.detail[0]?.msg : data.detail;
    throw new Error(detail || "Could not submit your interest — please try again.");
  }
  return data;
}
